import React, { createContext, useState, useContext } from 'react';

const ModeContext = createContext();

export const ModeProvider = ({ children }) => {
  const [isModeAdmin, setIsModeAdmin] = useState(false);

  const toggleMode = () => {
    setIsModeAdmin(prevMode => !prevMode);
  };

  return (
    <ModeContext.Provider value={{ isModeAdmin, toggleMode }}>
      {children}
    </ModeContext.Provider>
  );
};

export const useMode = () => useContext(ModeContext);
